import { render } from "./DistressSettingsMenu.vue?vue&type=template&id=0c0b59a3&scoped=true"
import script from "./DistressSettingsMenu.vue?vue&type=script&lang=js"
export * from "./DistressSettingsMenu.vue?vue&type=script&lang=js"

import "./DistressSettingsMenu.vue?vue&type=style&index=0&id=0c0b59a3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0b59a3"]])

export default __exports__